import { ArrowRightOutlined, SwapOutlined } from '@ant-design/icons';
import { Alert, Button, Tag } from 'antd';
import PlanDetailsCard from 'components/PlanDetailsCard/PlanDetailsCard';
import RowLoader from 'components/Sceletons/RowLoader';
import { Tariffs } from 'components/TariffsComponent/tariffsData';
import { runExtendTariff, checkIsTariffEnded, checkIsAwaitingPayment } from 'helpers/tariffPayment';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import { useAppSelector } from 'store/hook';
import classes from './TariffEnded.module.scss';
import Assets from 'assets/icons';

const appName =
  window.REACT_APP_BUILD_NAME !== 'REPLACE_REACT_APP_BUILD_NAME'
    ? window.REACT_APP_BUILD_NAME === 'athena'
      ? 'Athena'
      : 'TazaDeal'
    : process.env.REACT_APP_BUILD_NAME === 'athena'
      ? 'Athena'
      : 'TazaDeal';

const TariffEnded = () => {
  const [isPayingTariff, setIsPayingTariff] = React.useState(false);

  const { dataRoom, isLoadingRoom } = useAppSelector((store) => store.dataRoom);
  const { isLoadingUserData } = useAppSelector((store) => store.userData);
  const { messageApi } = useAppSelector((store) => store.windowState);

  const navigate = useNavigate();
  const { t } = useTranslation();

  const isLoading = isLoadingRoom || isLoadingUserData;
  const hasPaymentLink = Boolean(dataRoom?.tariff?.last_payment_intent?.link);
  const isTrial = dataRoom?.tariff?.tariff_name === Tariffs.Trial;
  const canPay = hasPaymentLink && !isTrial;

  React.useEffect(() => {
    if (dataRoom && !checkIsTariffEnded(dataRoom)) {
      if (checkIsAwaitingPayment(dataRoom)) {
        navigate(`/room/${dataRoom?.id}/awaitingPayment`);
      } else {
        navigate(`/room/${dataRoom?.id}/documents`);
      }
    }
  }, [dataRoom]);

  const navigateToTariffs = () => {
    if (!isLoading) {
      navigate(`/tariffs`);
      dataRoom?.id &&
        localStorage.setItem('ended_tariff_lifetime', dataRoom.id);
    }
  };

  const navigateToPayment = async () => {
    if (!dataRoom) return;
    setIsPayingTariff(true);

    try {
      await runExtendTariff(dataRoom, messageApi, t);
    } finally {
      setIsPayingTariff(false);
    }
  };
  return (
    <div className={classes.page}>
      <div className={classes.card}>
        <div className={classes.iconWrap}>
          <div className={classes.iconCircle}>
            <Assets.LockIcon className={classes.icon} />
          </div>
        </div>

        <Tag className={classes.statusTag}>
          <span className={classes.statusDot} />
          {t('tariffStatus.accessRestricted')}
        </Tag>

        {isLoading ? (
          <RowLoader width='320px' padding='0' height='32px' />
        ) : (
          <h1 className={classes.title}>{dataRoom?.name}</h1>
        )}
        <p className={classes.description}>
          {t('ended_tariff_lifetime.paymentOffer', { appName })}
        </p>
        <Alert
          className={classes.alert}
          type='warning'
          showIcon
          message={
            <span className={classes.alertTitle}>
              {t('filesRetained.title')}
            </span>
          }
          description={t('ended_tariff_lifetime.deletionWarning')}
        />

        <PlanDetailsCard room={dataRoom} isLoading={isLoading} />

        <div className={classes.actions}>
          {isLoading ? (
            <RowLoader width='180px' padding='0' height='36px' />
          ) : (
            canPay && (
              <Button
                type='primary'
                size='large'
                loading={isPayingTariff}
                onClick={navigateToPayment}
                icon={<ArrowRightOutlined />}
                iconPosition='end'
              >
                {t('ended_tariff_lifetime.tarrifsLink')}
              </Button>
            )
          )}

          {isLoading ? (
            <RowLoader width='180px' padding='0' height='36px' />
          ) : (
            <Button
              size='large'
              onClick={navigateToTariffs}
              icon={<SwapOutlined />}
            >
              {t('ended_tariff_lifetime.changeTariff')}
            </Button>
          )}
        </div>
      </div>
    </div>
  );
};

export default TariffEnded;
